/**
 * The supported image placeholder types
 *
 * Note: Values are in camel case as they are used for the [[OccImagePlaceholderAssets]] interface.
 */
export var ImagePlaceholderType;
(function (ImagePlaceholderType) {
    /**
     * The placeholder asset for an event gallery image.
     */
    ImagePlaceholderType["EventGallery"] = "eventGallery";
    /**
     * The placeholder asset for an event poster image.
     */
    ImagePlaceholderType["EventPoster"] = "eventPoster";
    /**
     * The placeholder asset for a film advertisement image.
     */
    ImagePlaceholderType["FilmAdvertisement"] = "filmAdvertisement";
    /**
     * The placeholder asset for a film backdrop image.
     */
    ImagePlaceholderType["FilmBackdrop"] = "filmBackdrop";
    /**
     * The placeholder asset for a film poster image.
     */
    ImagePlaceholderType["FilmPoster"] = "filmPoster";
    /**
     * The placeholder asset for a film still image.
     */
    ImagePlaceholderType["FilmStill"] = "filmStill";
    /**
     * The placeholder asset for a film title treatment image.
     */
    ImagePlaceholderType["FilmTitleTreatment"] = "filmTitleTreatment";
    /**
     * The placeholder asset for an item image.
     */
    ImagePlaceholderType["ItemImage"] = "itemImage";
    /**
     * The placeholder asset for a member photo.
     */
    ImagePlaceholderType["MemberPhoto"] = "memberPhoto";
    /**
     * The placeholder asset for a member reward image.
     */
    ImagePlaceholderType["MemberRewardImage"] = "memberRewardImage";
    /**
     * The placeholder asset for a member reward thumbnail.
     */
    ImagePlaceholderType["MemberRewardThumbnail"] = "memberRewardThumbnail";
    /**
     * The placeholder asset for a redirect payment method icon.
     */
    ImagePlaceholderType["RedirectPaymentMethodIcon"] = "redirectPaymentMethodIcon";
    /**
     * The placeholder asset for a site gallery image.
     */
    ImagePlaceholderType["SiteGallery"] = "siteGallery";
})(ImagePlaceholderType || (ImagePlaceholderType = {}));
